import { Injectable } from '@angular/core';
import { MessageService } from 'abp-ng2-module';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export default class ExtendedMessageService extends MessageService {
    swal: any;
    constructor() {
        super();
        this.swal = Swal;
    }
}
